import styled from "styled-components"
import { lazy, memo, Suspense, useEffect, useState } from "react";
import { Skeleton } from "antd";
import HeavenGrid from '../img/heaven_grid.png';

const TourDate = lazy(() => import ('../components/TourDate'));

const TourDateLazy = () => {
     const Card = styled.div `
        padding: 20px;
        width: min(calc(100% - 20px), 500px);
        height: 200px;
        position: relative;
        overflow: hidden;
        border-radius: 20px;
        font-family: '5dots';
        background: #e5e5e5;
        color: #3a3a3a;
        flex: 1 1 min(calc(100% - 20px), 500px);

        @media (max-width: 700px) {
        height: 150px;
        }
    `
    return <Card></Card>;
}

const getTours = async () => {
    let f1 = await fetch("https://h3llo-wor1d.github.io/static.hyperpup.pet/dates.json");
    let f2 = await f1.json();
    return f2;
}

export const TourGrid = memo(function TourGrid() {
    const [dates, setDates] = useState([]);

    const initData = async () => {
        let d = await getTours();
        setDates(d.dates);
    }

    useEffect(() => {
        initData();
    }, [])

    const Parent = styled.div`
    display: flex;
    flex-direction: row;
    flex-wrap: wrap;
    margin-top: 10px;
    margin-bottom: 10px;
    height: calc(100% - 40px);
    column-gap: 10px;
    row-gap: 10px;
    width: 100%;
    overflow-y: auto;
    overflow-x: hidden;
    justify-content: space-between;

    @media (max-width: 1109px) {
        justify-content: center;
    }
    `;

    if (!dates || dates.length === 0) {
        return <Parent>
            {new Array(6).fill(<TourDateLazy />)}
        </Parent>;
    }

    

    return (
        <Parent>
            <Suspense fallback={<TourDateLazy />}>
                {dates.map(date => <TourDate {...date} />)}
            </Suspense>
        </Parent>
    )
})